import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const FAQS = [
  {
    q: 'What does "B2B white label" install mean?',
    a: 'You own the client relationship and the invoice. We show up as your install crew — no branded shirts, no biz cards handed out. Your brand, our hands.',
  },
  {
    q: 'What surfaces do you wrap?',
    a: 'Cars, trucks, vans, sprinters, RVs, trailers, boats, walls, floors, windows, countertops, appliances, helmets — any paintable surface. We install PPF, color change, print & cut, and wall/floor graphics.',
  },
  {
    q: 'Which materials do you install?',
    a: '3M 1080/2080, Avery SW900, Orafol 970RA, Hexis Skintac, Aura PPF, Mactac wall/floor, plus most printable calendared and cast films. We are 3M Preferred and Avery Certified.',
  },
  {
    q: 'How is the Wrapulator different from other quote tools?',
    a: 'The Wrapulator is priced from real shop data — material cost per sqft, waste factor per film, and labor bands. Pro tier adds complexity multipliers, custom margin controls and branded PDF proposals for your clients.',
  },
  {
    q: "What's included in the 7-day free trial?",
    a: "Everything in Pro — no card charged until day 8, and you can cancel any time from Stripe's customer portal with one click.",
  },
  {
    q: 'Do you travel? What area do you cover?',
    a: 'HQ is Houston, TX. We deploy install teams nationwide through the Install Guild network — post a job, get vetted bids within 48 hours.',
  },
  {
    q: 'How long does a wrap take?',
    a: 'A full color change on a sedan usually runs 2-3 days. Fleets scale linearly — we can run parallel bays. Rush service is available at premium labor rate.',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="relative py-24 lg:py-32 border-b mi-line">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-10">
        <div className="mi-eyebrow mb-3">// FAQ</div>
        <h2 className="mi-headline text-5xl md:text-6xl mb-12">
          Answers. <span className="text-[#E63946]">No filler.</span>
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b mi-line-strong">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="mi-headline text-xl md:text-2xl text-left hover:text-[#E63946] hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/75 leading-relaxed text-base pb-6 pr-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
